import React, { useRef } from "react";
import styled from "styled-components";
import { DescriptionP, EmployeeCard, Line_282, NameHead, PositionP, SectionsIcon, ServicesIcon, TestimonialCard, TitleHead } from "../services";
import icon1 from '../../images/quotes.png';

const empvid = "https://ak03-video-cdn.slidely.com/promoVideos/videos/64/2a/642adecda3f09b37d2590fc2/final.mp4?dv=2"

const CareersContainer = styled.div`
    margin-top: 90px;
`;

const FreshStartBox = styled.div`
    background-color: #F1F1F1;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 5%;
`;

const RedHeader = styled.h2`
    color: #9D2222;
    text-align: center;
    font-family: Roboto;
    font-size: 30px;
    font-weight: 500;
    padding-bottom: 2%;

    @media screen and (max-width: 768px){
        font-size: 20px;
    }

`;

const Subheader = styled.h3`
    color: #595959;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: italic;
    font-weight: 500;
    padding-bottom: 2%;

    @media screen and (max-width: 768px){
        font-size: 18px;
    }
`;

const BoxText = styled.p`
    color: #595959;
    text-align: center;
    font-family: Sunflower;
    font-size: 16px;
    font-weight: 200;

    @media screen and (max-width: 768px){
        font-size: 18px;
    }
`;

const RedBoxContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 5%;

    @media screen and (max-width: 768px){
        
    }
`;

const RedBoxText = styled.p`
    background: #9D2222;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: white;
    margin-bottom: 0px;
    height: 50px;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: bold;

    @media screen and (max-width: 768px){
        width: 90%;
        font-size: 14px;
        font-weight: 600;
        padding-left: 10%;
        padding-right: 10%;
        font-family: 'Roboto';
    }
`;

const Widget = styled.div`
    width:100%;
    height:600px;
    display:flex;
    margin-top:5%;
    margin-left:1%;


   
    @media screen and (max-width: 768px){
    	margin-top:5%;
  

    }

`;



const TheFrame =styled.iframe`
    width:100%;
    height:400px; 
    border:0px;
    margin:0% 0% 0% 0%;
    overflow-y:hidded;


    @media screen and (max-width: 768px) {
        width:100%;
    }
  `;

const EmployeeGrowth = styled.div`
    /* display: flex;
    flex-direction: row;  */
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5%;
    justify-content: center; 
    margin-top: 5%;
    margin-bottom: 5%;
    
    @media screen and (max-width: 768px){
        display: inline-flex;
        flex-direction: column;
    }
`;

const RedTextOne = styled.p`
    color: #9D2222;
    font-family: Roboto;
    font-size: 30px;
    font-style: italic;
    font-weight: 500;
    margin-bottom: 5%;

    @media screen and (max-width: 768px){
        font-size: 24px;
        width: 80%;
        display: inline-flex;
    }
`;

const EndWrapper = styled.div`
    margin-top: 10%;
    margin-bottom: 15%;
`;
const BlackTextOne = styled.p`
    color: black;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 400;

    @media screen and (max-width: 768px){
        font-size: 16px;
        padding-left: 5%;
        padding-right: 5%;
    }
`;

const VideoCard = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 65%;
  max-height: 470px;
  /* place-self: flex-end; */

  @media screen and (max-width: 768px){
    width: 303px;
    height: 175px;
    justify-content: center;

  }
`;

const EmployeeCardWrapper = styled.div`
    display: flex;
    width: 100%;
    padding-top: 5%;
    padding-bottom: 5%;
    /* justify-content: center; */

    @media screen and (max-width: 768px){
        width: 100%;
        padding-right: 0px;
    }
`;


export function Careers(){
    const VideoRef = useRef(null);

    const handleLoadedMetadata = () => {
        VideoRef.current.currentTime = 1.00;
        VideoRef.current.pause();
    }


    
    return(
        <CareersContainer>
            <FreshStartBox>
                <RedHeader>NEED A FRESH START?</RedHeader>
                <Subheader>THRIVE WITH EXPEDIENT.</Subheader>
                <BoxText>We invest in our employees by developing skills and promoting from within. Apply today!</BoxText>
            </FreshStartBox>
            <RedBoxContainer>
                <RedBoxText>Check out our open positions. We look forward to hearing from you!</RedBoxText>
            </RedBoxContainer>
             <Widget>
				<script
                type="text/javascript"
                src="https://app.crelate.com/dist/candidateportal/libs-widget.all.min.js?v=1737586649"
                //src="https://app.crelate.com/dist/candidateportal/libs-widget.all.min.js?v=1709233876"
			 	//src="https://app.crelate.com/dist/candidateportal/libs-widget.all.min.js?v=1660678652"
			 	/>
				<TheFrame
                id="cr-main-widget" 
				data-org_name="expedientstaffingsolutions" 
				//data-config="pw_ShowOnly=all;pw_ShowJobsAs=list;pw_GroupJobsBy=none;pw_ShowLocationFilter=false;pw_ShowTagsFilter=false;pw_HyperlinksOpenAs=_parent;"
                // old crelate job config 
                data-config="pw_ShowOnly=featured;pw_ExcludeClosed=true;pw_ShowJobsAs=list;pw_GroupJobsBy=none;pw_ShowLocationFilter=true;pw_ShowTagsFilter=true;pw_HyperlinksOpenAs=_blank;"
                src="https://jobs.crelate.com/portal/expedientstaffingsolutions"
				title="crelate jobs"
				/>
			</Widget>
            <RedTextOne>Discover how we bolster the growth of our employees.</RedTextOne>
            <VideoCard>
                <video 
				 ref={VideoRef} 
				 width="100%"
				 height="100%" 
				 controls 
				 disablepictureinpicture 
				 controlslist="nodownload" 
				 muted
				 onLoadedMetadata={handleLoadedMetadata}
				 >
				<source src={empvid} type="video/mp4" />
					Sorry, Your browser doesn't support Videos.
				</video>
            </VideoCard>
            <EmployeeGrowth id="employee-growth">
                <EmployeeCardWrapper style={{justifyContent: "flex-end"}}>
                    <EmployeeCard >
                        <SectionsIcon>
                            <ServicesIcon src={icon1} alt="giant red circle with giant white quotes"/>
                            <NameHead>Aurora Perez</NameHead>
                            <PositionP>Administrator</PositionP>
                        </SectionsIcon>
                        <Line_282 />
                        <TestimonialCard>
                            <TitleHead>
                                so grateful
                            </TitleHead>
                            <DescriptionP>
                                Gina sees potential in you that you sometimes don’t even see in yourself, and she doesn’t give up on you. I am so grateful to have met Gina.
                            </DescriptionP>
                        </TestimonialCard>
                    </EmployeeCard>
                </EmployeeCardWrapper>
                <EmployeeCardWrapper>
                    <EmployeeCard >
                        <SectionsIcon>
                            <ServicesIcon src={icon1} alt="giant red circle with giant white quotes"/>
                            <NameHead>Mercedes Rodriguez</NameHead>
                            <PositionP>Trainer</PositionP>
                        </SectionsIcon>
                        <Line_282 />
                        <TestimonialCard>
                            <TitleHead>
                                an amazing experience
                            </TitleHead>
                            <DescriptionP>
                                Guidance from my superiors not only helped me become a professional, but helped me evolve as an individual.
                            </DescriptionP>
                        </TestimonialCard>
                    </EmployeeCard>
                </EmployeeCardWrapper>
            </EmployeeGrowth>
            <EndWrapper>
                <RedTextOne>Not seeing the perfect role?</RedTextOne>
                <BlackTextOne>
                    <a style={{color: "#000", textDecoration: "underline"}}href="mailto:info@exp-staffing.com">Shoot us an email</a> attaching your resume.
                    If you're a fit, we'll reach out!
                </BlackTextOne>
            </EndWrapper>
        </CareersContainer>
    )
};